export const SIGNED_IN = 'SIGNED_IN'
export const SIGNED_OUT = 'SIGNED_OUT'
export const USER_LOADED = 'USER_LOADED'
export const USER_UNLOADED = 'USER_UNLOADED'
export const SET_USER_DTO = 'SET_USER_DTO'